// Time / size formatting helpers. Times are displayed as m:ss.cc (centiseconds)
// which is finer than one frame at any common video frame rate.

export function formatTime(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) seconds = 0
  const centis = Math.round(seconds * 100)
  const cc = centis % 100
  let total = Math.floor(centis / 100)
  const s = total % 60
  total = Math.floor(total / 60)
  const m = total % 60
  const h = Math.floor(total / 60)
  const pad = (n) => String(n).padStart(2, '0')
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}.${pad(cc)}` : `${m}:${pad(s)}.${pad(cc)}`
}

// Accepts "83.4", "1:23.4", "01:23", "1:01:01.5". Returns seconds or null.
export function parseTime(text) {
  if (typeof text !== 'string') return null
  const trimmed = text.trim()
  if (!trimmed) return null
  const parts = trimmed.split(':')
  if (parts.length > 3) return null
  const nums = []
  for (const part of parts) {
    const p = part.trim()
    if (!/^\d+(\.\d+)?$/.test(p)) return null
    nums.push(parseFloat(p))
  }
  if (nums.length === 1) return nums[0]
  for (let i = 1; i < nums.length; i++) {
    if (nums[i] >= 60) return null
  }
  return nums.reduce((acc, n) => acc * 60 + n, 0)
}

export function formatFileSize(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B'
  if (bytes < 1024) return `${Math.round(bytes)} B`
  const units = ['KB', 'MB', 'GB', 'TB']
  let value = bytes
  let unitIndex = -1
  do {
    value /= 1024
    unitIndex++
  } while (value >= 1024 && unitIndex < units.length - 1)
  return `${value.toFixed(1)} ${units[unitIndex]}`
}
